import { useClipboard } from '@vueuse/core'

/** 复制文字 */
export const useCopy = async (text: string) => {
  const toast = useToast()
  const { t } = useI18n()
  const { isMdWidth } = useClientWidth()
  const { copied, copy, isSupported } = useClipboard({ legacy: true })
  // 兼容性检查
  if (!isSupported) {
    toast.add({
      color: 'error',
      title: t('message.error.supported'),
      icon: 'material-symbols:warning',
    })
    return
  }
  // 开始复制
  await copy(text)
    .then(() => {
      if (copied.value) {
        toast.add({
          color: 'success',
          title: t('message.success.copy'),
          icon: 'material-symbols:check',
        })
      } else {
        toast.add({
          color: 'error',
          title: t('message.error.copy'),
          icon: 'material-symbols:close',
        })
      }
    })
    .catch(err =>
      toast.add({
        color: 'error',
        title: t('message.error.copy'),
        description: err,
        icon: 'material-symbols:close',
      }),
    )
}
